import request from '@/utils/request'
let apiName = 'bookTask'
// 获取任务信息
export function info(id) {
  return request({
    url: `/api/app/${apiName}`,
    data:{
      PageIndex:1,
      PageSize:1000,
      Sorting: 'order ASC',
      bookSubId: id
    },
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/book-task.js